import * as Yup from 'yup';
import { getEmailValidationSchema } from '../../../../utils/ValidationSchema';

export default Yup.object().shape({
  email: getEmailValidationSchema({ isRequired: true, isNullable: false })
});
